import { publicKioskLinkRedirectPath, publicKioskLinkLearnersPath } from '~/routes'
import { handleApiError } from '~/service/http'

const postHeaders = () => {
  const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...(csrf && { 'X-CSRF-Token': csrf }),
  }
}

export const redirectKioskLearner = async (secretId, params) => {
  const response = await fetch(publicKioskLinkRedirectPath(secretId), {
    method: 'POST',
    headers: postHeaders(),
    body: JSON.stringify(params),
  })
  if (!response.ok) {
    try {
      await handleApiError(response, 'Something went wrong. Please try again.')
    } catch (error) {
      // 404 specifically means "no learner matched this identifier" (see #set_learner) - callers
      // use this to distinguish "not found" from a 422 training-assignment failure on confirm.
      error.status = response.status
      throw error
    }
  }
  const json = await response.json()
  return json?.data
}

export const createKioskLearner = async (secretId, data) => {
  const response = await fetch(publicKioskLinkLearnersPath(secretId), {
    method: 'POST',
    headers: postHeaders(),
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    try {
      await handleApiError(response, 'Failed to create learner')
    } catch (error) {
      error.status = response.status
      throw error
    }
  }

  if (response.status === 204) return null

  const text = await response.text()
  return text ? JSON.parse(text) : null
}
